module.exports = __webpack_public_path__ + "img/zc-11.bfabc7be.svg";